import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FullScreenSpinner } from "../../../components/exports";
import { DialogContext } from "../../../contexts/DialogueContext";
import SupportOperatorSurveyDialog from "../dialogs/SupportOperatorSurveyDialog";

export default function Survey() {
    let { id } = useParams();
    const navigate = useNavigate();

    const { openDialog } = useContext(DialogContext);

    useEffect(() => {
        openDialog(<SupportOperatorSurveyDialog id={id} />, (result) => {
            navigate("/");
        });
    }, []);

    return <FullScreenSpinner />;
}
